// Referee assigner page
// - Shows Spinner while the record could still arrive
// - Renders <h1> error if the assigner is not found

import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import RefereeAssignerCard from '../components/RefereeAssignerCard';
import Spinner from '../components/Spinner';
import { useUser } from '../utils/hooks';
import { UsersRoles } from '../utils/enums';

export default function PageRefereeAssigner() {
  const { assignerId } = useParams();
  const { entity: found, isResolved } = useUser(assignerId);

  const assigner =
    found?.role === UsersRoles.REFEREE_ASSIGNER ? found : undefined;

  if (!assigner && !isResolved) {
    return (
      <Layout screenSized className='page-referee-assigner'>
        <Spinner show />
      </Layout>
    );
  }

  if (!assigner) {
    return (
      <Layout screenSized className='page-referee-assigner'>
        <h1>{`Error: no route matches url "/referee-assigners/${assignerId}"`}</h1>
      </Layout>
    );
  }

  return (
    <Layout className='page-referee-assigner' trail>
      <RefereeAssignerCard assigner={assigner} />
    </Layout>
  );
}
